
export default function Header() {
    return (
        <>
            <header class="border-b border-green-700 text-center md:text-left">
                <h1 class="text-2xl font-bold text-green-500 font-mono m-0">Akshay Kumar</h1>
                <p class="text-sm text-gray-400 header-spacing font-mono">Software Engineer</p>
            </header>
        </>
    )
}